import { cva } from 'class-variance-authority';

const dropdownMenuItemVariants = cva(
  "group/dropdown-menu-item relative flex cursor-pointer select-none items-center gap-2 rounded-md p-2 text-sm outline-none hover:bg-surface-hover hover:text-text-primary focus:bg-surface-hover focus:text-text-primary active:bg-surface-pressed data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg:not([class*='size-'])]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: '',
        destructive:
          'text-validation-destructive hover:bg-validation-destructive-muted hover:text-validation-destructive-hover focus:bg-validation-destructive-muted focus:text-validation-destructive active:bg-validation-destructive-muted active:text-validation-destructive-pressed',
      },
      inset: {
        true: 'ps-8',
      },
      selected: {
        true: 'bg-surface-selected hover:bg-surface-selected-hover focus:bg-surface-selected-hover active:bg-surface-selected-pressed',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export { dropdownMenuItemVariants };
